import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { Router } from '@angular/router';
import { firstValueFrom, Subject } from 'rxjs';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ErrorhandlingService } from 'src/app/services/errorhandling.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-reset-password',
    imports: [ MatToolbarModule, FormsModule, MatIconModule, ReactiveFormsModule, MatLabel, MatFormFieldModule, NgIf],
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent implements OnInit {

  form: any = {
    email: null,
    newpassword: null,
    confirmpassword: null
  };
  token: string;
  loginForm: FormGroup;
  destroy$: Subject<boolean> = new Subject<boolean>();
  hide_new: boolean = true;
  hide_confirm: boolean = true;
  changeFailed: boolean = false;
  errorMessage: string = "";
  changeSuccessful: boolean = false;

  constructor(private authenticationService: AuthenticationService, private route: ActivatedRoute) { 
  }

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get("token")
    this.route.queryParamMap.subscribe(queryParams => {
      this.token = queryParams.get("token");
    })
    this.loginForm = new FormGroup({
      username: new FormControl(this.form.username, [
        Validators.required
      ]),
      newpassword: new FormControl(this.form.newpassword,
        [Validators.required]),
      confirmpassword: new FormControl(this.form.confirmpassword,
        [Validators.required]),
      });

  }

  async onClick() {
    this.changeFailed = false;
    this.changeSuccessful = false;
    const data = await firstValueFrom(this.authenticationService.setNewPassword(this.form.email, this.form.newpassword, this.token));
    if (data) {
      this.changeSuccessful = true;
    } else {
      this.changeFailed = true;
        this.errorMessage = "Something went wrong while saving your new password."
    }
  }

  get email() { return this.loginForm.get('email'); }  
  get newpassword() { return this.loginForm.get('newpassword'); }  
  get confirmpassword() { return this.loginForm.get('confirmpassword'); }  

}
